<div class="vtr-modal-snapshot position-relative">
	<div class="row modal-information">
		<h1 class="title" id="snapshot-modal-title" role="heading">{{ 'snapshot.replaceBaseline' | translate }}</h1>
		<p class="description" id="snapshot-modal-description" role="text">{{ 'snapshot.replaceBaselineDescription' | translate }}</p>
	</div>

	<vtr-ui-snapshot-list-info
		[componentId]="'snapshot-replace-baseline-list'"
		[componentList]="componentItemList"
		(selectAny)="receiveSelect()">
	</vtr-ui-snapshot-list-info>

	<div class="row button-row">
		<vtr-material-button
			linkId="snapshot-modal-run-selected-components-btn"
			[isDisabled]="disableButtonRun"
			[label]= " 'snapshot.replaceBaseline' | translate | uppercase "
			(buttonClick)="onClickRun()"
			heightSize="lg">
		</vtr-material-button>
	</div>

	<div class="btn-modal-close">
		<vtr-ui-close-button
			linkId="snapshot-modal-close-btn"
			(clickClose)="closeModal()">
		</vtr-ui-close-button>
	</div>
</div>
